import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Project.css";

function Project() {
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  // ✅ Full project data
  const projects = [
    {
      title: "Kreshbajini (Blog)",
      category: "Web Apps",
      tech: ["WordPress"],
      description:
        "Resolved plugin and SSL issues, enabled social media previews, and improved performance and security.",
      image:
        "https://api.microlink.io?url=https://kreshbajini.com/&screenshot=true&meta=false&embed=screenshot.url",
      link: "https://kreshbajini.com/",
    },
    {
      title: "CFHRSW (NGO)",
      category: "Web Apps",
      tech: ["PHP", "HTML", "CSS", "JavaScript"],
      description:
        "Dynamic NGO site with donation system, PHP-based admin panel, and responsive UI for all devices.",
      image:
        "https://api.microlink.io?url=https://cfhrsw.org&screenshot=true&meta=false&embed=screenshot.url",
      link: "https://cfhrsw.org",
    },
    {
      title: "Radha Enterprises (Interior Designing)",
      category: "UI Design",
      tech: ["PHP", "HTML", "CSS"],
      description:
        "Responsive and elegant design portfolio for an interior design company showcasing services and gallery.",
      image:
        "https://api.microlink.io?url=https://radhaenterprises.co.in&screenshot=true&meta=false&embed=screenshot.url",
      link: "https://radhaenterprises.co.in",
    },
    {
      title: "Quicklearn (Educational Website)",
      category: "Web Apps",
      tech: ["React JS", "HTML", "CSS"],
      description:
        "Community for RTU B.Tech students offering notes, study material, and previous year papers.",
      image:
        "https://api.microlink.io?url=https://quicklearn-rtu.netlify.app/&screenshot=true&meta=false&embed=screenshot.url",
      link: "https://quicklearn-rtu.netlify.app/",
    },
    {
      title: "Musify (Spotify Clone)",
      category: "Mini Projects",
      tech: ["React JS", "HTML", "CSS"],
      description:
        "Spotify API-based app with playlists, top tracks, and user authentication using developer APIs.",
      image:
        "https://api.microlink.io?url=https://musify55.netlify.app/&screenshot=true&meta=false&embed=screenshot.url",
      link: "https://musify55.netlify.app/",
    },
    {
      title: "Used Car Price Prediction Tool",
      category: "Machine Learning",
      tech: ["HTML", "CSS", "JavaScript", "ML"],
      description:
        "College project using ML model to predict used car prices. Built with Python backend and JS frontend.",
      image:
        "https://api.microlink.io?url=http://nitinagrawal.pythonanywhere.com/&screenshot=true&meta=false&embed=screenshot.url",
      link: "http://nitinagrawal.pythonanywhere.com/",
    },
    {
      title: "Credit Score Prediction",
      category: "Machine Learning",
      tech: ["HTML", "CSS", "Bootstrap"],
      description:
        "A simple ML-based project to predict credit score categories using a trained dataset.",
      image:
        "https://api.microlink.io?url=http://piyushagarwal55.pythonanywhere.com/&screenshot=true&meta=false&embed=screenshot.url",
      link: "http://piyushagarwal55.pythonanywhere.com/",
    },
    {
      title: "Expense Management",
      category: "Web Apps",
      tech: ["React JS", "HTML", "CSS"],
      description:
        "React-based app to track monthly and yearly expenses with charts and detailed analytics.",
      image:
        "https://api.microlink.io?url=https://precious-palmier-6e7713.netlify.app/&screenshot=true&meta=false&embed=screenshot.url",
      link: "https://precious-palmier-6e7713.netlify.app/",
    },
    {
      title: "Flickz",
      category: "Mini Projects",
      tech: ["HTML", "CSS", "JavaScript", "Bootstrap"],
      description:
        "Movie search website with API integration for title search, built for a college project.",
      image:
        "https://api.microlink.io?url=http://flickz.freecluster.eu/?i=1&screenshot=true&meta=false&embed=screenshot.url",
      link: "http://flickz.freecluster.eu/?i=1",
    },
    {
      title: "Weather Forecast",
      category: "Mini Projects",
      tech: ["React JS", "HTML", "CSS"],
      description:
        "Weather forecast app using OpenWeather and GeoDB APIs, showing 7-day predictions and temperature data.",
      image:
        "https://api.microlink.io?url=https://bespoke-puppy-f8db27.netlify.app/&screenshot=true&meta=false&embed=screenshot.url",
      link: "https://bespoke-puppy-f8db27.netlify.app/",
    },
    {
      title: "Cryptocurrency Price Update",
      category: "Mini Projects",
      tech: ["React JS", "HTML", "CSS"],
      description:
        "Crypto tracker displaying price, market cap, and percentage change with API-driven live updates.",
      image:
        "https://api.microlink.io?url=https://clinquant-starburst-7f74f5.netlify.app/&screenshot=true&meta=false&embed=screenshot.url",
      link: "https://clinquant-starburst-7f74f5.netlify.app/",
    },
    {
      title: "BMI Calculator",
      category: "Android Apps",
      tech: ["Android Studio", "Java"],
      description:
        "First Android app that calculates Body Mass Index. Available as APK for direct download.",
      image: "images/bmi.jpg",
      link: "app/app-debug.apk",
      download: true,
    },
    {
      title: "StayInn",
      category: "UI Design",
      tech: ["HTML", "CSS", "JavaScript", "Bootstrap"],
      description:
        "Hotel booking front-end project with sign-in, sign-up, contact, and room showcase pages.",
      image:
        "https://api.microlink.io?url=https://piyushagarwal55.github.io/hotelwebsite/&screenshot=true&meta=false&embed=screenshot.url",
      link: "https://piyushagarwal55.github.io/hotelwebsite/",
    },
    {
      title: "Paathshala (NGO Website)",
      category: "Web Apps",
      tech: ["React JS", "HTML", "CSS"],
      description:
        "NGO website developed as a freelance project, focusing on design and accessibility.",
      image:
        "https://api.microlink.io?url=http://paathshala.freecluster.eu&screenshot=true&meta=false&embed=screenshot.url",
      link: "http://paathshala.freecluster.eu",
    },
  ];

  const filteredProjects =
    filter === "All"
      ? projects
      : projects.filter((p) => p.category === filter);

  return (
    <section
      className="project-section"
      id="projects"
      style={{
        padding: "60px 20px",
        // background: "#0b0d17",
        color: "#fff",
      }}
    >
      <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
        <h2
          style={{
            textAlign: "center",
            fontSize: "2.2rem",
            marginBottom: "30px",
          }}
          data-aos="fade-up"
        >
          All Projects
        </h2>

        {/* Filter Buttons */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            gap: "10px",
            marginBottom: "40px",
          }}
          data-aos="fade-up"
        >
          {[
            "All",
            "Web Apps",
            "UI Design",
            "Mini Projects",
            "Machine Learning",
            "Android Apps",
          ].map((cat) => (
            <button
              key={cat}
              onClick={() => setFilter(cat)}
              className={`filter-btn ${filter === cat ? "active" : ""}`}
              style={{
                background: filter === cat ? "#3b82f6" : "transparent",
                color: filter === cat ? "#fff" : "#aaa",
                border: "1px solid #3b82f6",
                padding: "8px 18px",
                borderRadius: "25px",
                cursor: "pointer",
                transition: "all 0.3s ease",
              }}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Project Grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "25px", justifyContent:"center",
          }}
        >
          {filteredProjects.map((proj, index) => (
            <div
              key={index}
              data-aos="fade-up"
              data-aos-delay={index * 100}
              style={{
                background: "#111428",
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                transition: "transform 0.3s ease",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = "translateY(-6px)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = "translateY(0)")
              }
              className="project-card"
            >
              <a
                href={proj.link}
                target={proj.download ? "_self" : "_blank"}
                rel="noopener noreferrer"
                download={proj.download || false}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <img
                  src={proj.image}
                  alt={proj.title}
                  style={{
                    width: "100%",
                    height: "200px",
                    objectFit: "cover",
                  }}
                />
                <div style={{ padding: "18px" }}>
                  <h4 style={{ marginBottom: "10px", color: "#fff" }}>
                    {proj.title}
                  </h4>
                  <p
                    style={{
                      fontSize: "0.9rem",
                      color: "#ccc",
                      marginBottom: "10px",
                      minHeight: "70px",
                    }}
                  >
                    {proj.description}
                  </p>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "6px",
                    }}
                  >
                    {proj.tech.map((tag, i) => (
                      <span
                        key={i}
                        style={{
                          fontSize: "0.8rem",
                          background: "#1e293b",
                          color: "#3b82f6",
                          padding: "4px 10px",
                          borderRadius: "8px",
                        }}
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Project;
